<template>
    <div>
        <div class="modal hide fade" id="modalPaymentPointOfSales" tabindex="-1" role="dialog" aria-labelledby="modalCustomerForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Payment
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-right">Method</label>
                                    <div class="col-sm-9">
                                        <div class="row">
                                            <div class="col-md-4" v-for="(m, index) in paymentMethodList" :key="index">
                                                <div class="card card-active" v-if="m.active" @click="addPaymentMethod(index)"><div class="card-body">{{ m.name }}</div></div>
                                                <div class="card card-menu " v-else @click="addPaymentMethod(index)"><div class="card-body">{{ m.name }}</div></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-right">Amount</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="payment.price" class="form-control" v-money="money"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <pre>{{ payment }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PaymentPointOfSales',
  data () {
    return {
      methodList: [{
        name: 'Cash',
        method: 'cash',
        bank_id: null,
        active: false
      }],
      money: {
        total: '0',
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      payment: {
        id: null,
        payment_no: null,
        sale_no: null,
        payment_date: null,
        price: null,
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: null,
        lock: null,
        status: null,
        journal_code: null
      }
    }
  },
  computed: {
    ...mapState({
      paymentMethodList: state => state.banks.paymentMethodList
    })
  },
  methods: {
    save () {
      const method = this.paymentMethodList.find(d => d.active === true)
      var obj = {
        payment_no: null,
        sale_no: null,
        payment_date: null,
        price: this.payment.price,
        method_id: method.method,
        type_id: null,
        bank_id: method.bank_id,
        notes: null,
        lock: null,
        status: null,
        journal_code: null
      }
      this.$emit('savePayment', obj)
    },
    addPaymentMethod (index) {
      var array = this.paymentMethodList
      for (let i = 0; i < array.length; i++) {
        array[i].active = false
      }
      var method = this.paymentMethodList[index]
      method.active = true
      console.log(method)
    }
  },
  mounted () {
  }
}
</script>
<style>
.card-menu {
  border: 1px solid #ccc;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}
.card-menu:hover {
  background-color: blue;
  color: white;
}
.card-active {
  border: 1px solid #ccc;
  cursor: pointer;
  background-color: blue !important;
  color: white;
  font-weight: bold;
  font-size: 14px;
}
</style>
